export function GlobalError(field, setIsError, setErrMsg) {
    if (field != null)
        if (field.toString().trim().toLowerCase() == "ig" || field.toString().trim().toLowerCase() == "gtn" || field.toString().trim().toLowerCase() == "cmc") {
            setErrMsg("LP name should not be exposed")
            setIsError(true);
        }
}